const mutation = {
  getStatusList(state, data) {
    state.statusList = data;
  },
  setMainStatus(state, Id) {
    state.filter.mainStatus = Id;
  },
  setSubStatus(state, Id) {
    state.filter.status = Id;
  },
  setSearchTerm(state, data) {
    state.filter[data.column] = data.query;
  },
  setPage(state, page) {
    state.filter.page = page;
  },
  setDateRange(state, dates) {
    state.filter.date_range = dates;
  },
  setGstType(state, id) {
    state.filter.gst_type = id;
  },
  setNoteType(state, id) {
    state.filter.note_type = id;
  },
  setTransporter(state, transporterId) {
    state.filter.transporter_id = transporterId;
  },
  setSearchQuery(state, query) {
    state.filter.reference_number = query;
  },
  loadingCheck(state, status) {
    state.isLoading = status;
  },
  progressCheck(state, status) {
    state.inProgress = status;
  },
  setBulkLoading(state, status) {
    state.inXLSProgress = status;
  },
  resetInvoices(state, data) {
    state.invoices = data;
  },
  paginationCheck(state, status) {
    state.isPaginating = status;
  },
  setInvoices(state, data) {
    if (data.length) {
      state.filter.page += 1;
      state.hasEmpty = false;
    } else {
      state.hasEmpty = true;
    }
    const result = state.invoices.concat(data);
    state.invoices = result;
  },
  setCustomFields(state, data) {
    state.customFields = data;
  },
  setReturnFields(state, data) {
    state.returnFields = data;
  },
  setInvoice(state, data) {
    state.extractFirstPayment = (data.order_payments.length) ? data.order_payments[0] : {};
    state.extractTax = (data.tax) ? data.tax : {};
    state.invoice = data;
  },
  setVoucher(state, vouchers) {
    state.vouchers = vouchers;
  },
  setTransporters(state, data) {
    data.unshift({ id: 'all', name: 'All' });
    state.transporterAll = data;
  },
  voucherUpdatedDates(state, data) {
    state.paymentUpdatedDates = data;
  },
  setComments(state, data) {
    state.comments = data;
  },
  commentLoading(state, status) {
    state.commentLoading = status;
  },
  setInvoiceType(state, data) {
    state.selectedInvoiceType = data;
  },
};

export default mutation;
